import { render } from "./InputComponent.vue?vue&type=template&id=c8ef1f66&scoped=true"
import script from "./InputComponent.vue?vue&type=script&lang=js"
export * from "./InputComponent.vue?vue&type=script&lang=js"

import "./InputComponent.vue?vue&type=style&index=0&id=c8ef1f66&scoped=true&lang=css"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8ef1f66"]])

export default __exports__